import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import ParticleBackground from './ParticleBackground';
import '../styles/Footer.css';
import {
  FaFacebook,
  FaInstagram,
  FaXTwitter,
  FaWhatsapp,
} from 'react-icons/fa6';
import logo from '../images/logo.png';

const Footer = () => {
  const socialLinks = [
    { icon: Mail, label: 'Email', href: 'mailto:thomas@effectivestaff.co.uk' , target: '_blank', rel: 'noopener noreferrer' },
    { icon: FaFacebook, label: 'Facebook', href: 'https://www.facebook.com/effectiveglobalstaff?mibextid=ZbWKwL' , target: '_blank', rel: 'noopener noreferrer' },
    { icon: FaInstagram, label: 'Instagram', href: 'https://www.instagram.com/effectiveglobalstaff/' , target: '_blank', rel: 'noopener noreferrer' },
    { icon: FaXTwitter, label: 'X', href: 'https://www.x.com/effectivegs' },
    { icon: FaWhatsapp, label: 'WhatsApp', href: 'https://wa.me/447446301591' , target: '_blank', rel: 'noopener noreferrer' },
  ];

  const footerLinks = {
    company: [
      { label: 'About Us', href: '/about' },
      { label: 'Request Demo', href: '/demo' },
      { label: 'Book Consultations', href: '/book' },
      { label: 'Careers', href: '/careers' },
    ],
    product: [
      { label: 'Features', href: '/features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Security', href: '/security' },
      { label: 'Support', href: '/support' }
    ],
    resources: [
      { label: 'Services', href: '/services' },
      { label: 'Values', href: '/values' },
      { label: 'Vision', href: '/vision' }
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'GDPR Compliance', href: '/gdpr' },
      { label: 'Cookie Policy', href: '/cookies' }
    ]
  };

  return (
    <footer className="footer">
      <ParticleBackground />

      <div className="footer-inner">

        {/* Footer Top: Brand + Nav */}
        <motion.div
          className="footer-top"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon-box">
                <img src={logo} alt="Effective Global Staff Logo" className="footer-logo-img" />
              </div>
              <div>
                <h3>Effective Global Staff</h3>
                <p>Payroll, HR, invoicing, and accounts — one platform for growing businesses.</p>
              </div>
            </div>

            <div className="footer-socials">
              {socialLinks.map((social, idx) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={idx}
                    href={social.href}
                    className="social-icon"
                    whileHover={{ y: -3, scale: 1.08 }}
                    whileTap={{ scale: 0.95 }}
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Nav Columns */}
          <motion.div
            className="footer-links-grid"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.08 }}
          >
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                {footerLinks.company.map((link, idx) => (
                  <li key={idx}>
                    <Link to={link.href} className="footer-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Product</h4>
              <ul>
                {footerLinks.product.map((link, idx) => (
                  <li key={idx}>
                    <Link to={link.href} className="footer-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link, idx) => (
                  <li key={idx}>
                    <Link to={link.href} className="footer-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Legal</h4>
              <ul>
                {footerLinks.legal.map((link, idx) => (
                  <li key={idx}>
                    <Link to={link.href} className="footer-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </motion.div>

        {/* Footer Bottom */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.12 }}
        >
          <p>&copy; 2026 Effective Global Staff. All rights reserved.</p>
          <p>Built with care for growing businesses. <span className="accent">Secure. Compliant. Reliable.</span></p>
        </motion.div>

      </div>
    </footer>
  );
};

export default Footer;